export const certificateModalQueriesKeys = {
  GET_MTLS_CLIENT_CERTIFICATE: 'get_mtls_client_certificate',
  GET_MTLS_CLIENT_KEY: 'get_mtls_client_key',
  CHECK_CERTIFICATE: 'check_certificate'
}
